<template>
    <div>
        <BCardBody class="mt-0">
            <BRow>
                <BCol cols="12" md="3"  xxl="6" >
                    <label>{{$t('Show')}}</label>
                    <vSelect v-model="perPage"  :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" :reduce="val => val"/>
                    <label>{{$t('entries')}}</label>
                </BCol>
                <BCol cols="12" md="9">
                    <div class="d-flex align-items-center justify-content-end">
                        <BDropdown
                        id="dropdown-3"
                        text="Exportar"
                        variant="success"
                        class="mr-1"
                        >
                            <BDropdownItem @click="exportMovementsPDFemployee" v-if="user.role==='Empleado'">PDF última caja</BDropdownItem>
                            <BDropdownItem @click="exportMovementsPDF" v-if="user.role==='Superadministrador'">PDF</BDropdownItem>
                            <BDropdownItem @click="exportMovementsCSV">CSV</BDropdownItem>
                            <BDropdownItem @click="exportMovementsXLS">XLS</BDropdownItem>
                        </BDropdown>
                        <BButton  v-if="ability.can('create', 'movement')" variant="primary"  :to="{ name: 'cash-movements-add'}" class="text-nowrap" > Añadir movimiento </BButton>
                    </div>
                </BCol>
            </BRow>
            </BCardBody>
        <BTable responsive ref="cashTable" id="movementsTable" striped :items="fetchMovements" :fields="fields">
            <template #cell(movement_type.name)="data">
                <!-- <span v-if="data.item.movement_type_id == 3 || data.item.movement_type_id == 4" class="text-muted"> {{ data.item.movement_type.name }} </span>
                <span v-else> {{ data.item.movement_type.name }} </span> -->
                <BLink class="text-muted" v-if="data.item.movement_type_id == 3 || data.item.movement_type_id == 4" :to="{ name: 'cash-movements-view', params: { id: data.item.id } }"> {{ data.item.movement_type.name }} </BLink>
                <BLink v-else :to="{ name: 'cash-movements-view', params: { id: data.item.id } }"> {{ data.item.movement_type.name }} </BLink>

            </template>
            <template #cell(amount)="data">
                <span v-if="data.item.movement_type_id == 3 || data.item.movement_type_id == 4" class="text-muted"> {{ formatCurrency(data.item.amount) }} </span>
                <span v-else> {{ formatCurrency(data.item.amount) }} </span>
            </template>
            <template #cell(student)="data">{{ data.item.invoice ? data.item.invoice.student.full_name : (data.item.expense ? data.item.expense.provider.name : '-') }}</template>
            <template #cell(observations)="data">{{ data.item.observations ? data.item.observations : '-' }}</template>
            <template #cell(emit_date)="data">{{ format(new Date (data.item.emit_date), 'dd-MM-yyyy, kk:mm:ss') }}</template>
            <template #cell(references)="data">
                    <BLink v-if="data.item.invoice_id" :to="{ name: 'invoices-view', params: { id: data.item.invoice_id } }"> {{ data.item.invoice ? data.item.invoice.name : ''  }} </BLink>
                    <BLink v-if="data.item.expense_id" :to="{ name: 'expenses-view', params: { id: data.item.expense_id } }"> {{ data.item.expense ? data.item.expense.name : '' }} </BLink>
                </template>
            <template #cell(actions)="data">
                    <BDropdown variant="link" no-caret>
                        <template #button-content>
                            <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                        </template>
                        <BDropdownItem :to="{ name: 'cash-movements-view', params: { id: data.item.id } }" v-if="ability.can('read', 'movement')">
                            <FeatherIcon icon="FileTextIcon" />
                            <span class="align-middle ml-50">{{$t('Details')}}</span>
                        </BDropdownItem>

                        <BDropdownItem :to="{ name: 'cash-movements-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'movement')">
                            <FeatherIcon icon="EditIcon" />
                            <span class="align-middle ml-50">{{$t('Edit')}}</span>
                        </BDropdownItem>

                        <BDropdownItem @click="deletePopup(data.item.id, 'movements/deleteMovement', 'cash-selector')" v-if="ability.can('delete', 'movement')">
                            <FeatherIcon icon="TrashIcon" />
                            <span class="align-middle ml-50">{{$t('Delete')}}</span>
                        </BDropdownItem>
                    </BDropdown>
                </template>
        </BTable>

        <BPagination class="m-2" v-model="currentPage" :total-rows="totalCash" :per-page="perPage"></BPagination>
        
        <BModal ref="movementExportModal" centered hide-footer >
            <p>Introduce las fechas: </p>
        <BRow>
                <DatepickerValidated vsName="Fecha de inicio" :vsModel.sync="startDateModal" vsRequired/>
                <DatepickerValidated vsName="Fecha de fin" :vsModel.sync="endDateModal" vsRequired :vsMin="startDateModal"/>
                <BCol>
                <BButton  @click="exportMovements(cash.id, typeExportSelected, true)" variant="primary">Exportar</BButton>
                </BCol>
            </BRow>
        </BModal>
    </div>
</template>

<script>
import ability from '@/libs/acl/ability';
import { inject, ref } from '@vue/composition-api';
import { BPagination, BTable, BDropdown, BDropdownItem, BLink, BRow, BCol, BButton, BCardBody, BModal} from 'bootstrap-vue';
import popups from '@/hooks/popups'
import cashMovementsModule from '../../cash-movements/cashMovementsModule';
import store from '@/store';
import { onUnmounted } from '@vue/composition-api';
import { format } from 'date-fns';
import currency from '@/utils/currency'
import cashMovementsListQuery from '../../cash-movements/cash-movements-list/cashMovementsListQuery';
import vSelect from 'vue-select'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import exportUtils from '@/hooks/exportUtils'



export default {
    components: { BTable, BPagination, BDropdown, BDropdownItem, BLink, BRow, BCol, BButton, vSelect, BCardBody, BModal, DatepickerValidated },
    setup() {
        const { fetchMovements, tableColumns, perPage, currentPage, totalCash, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, cashTable, refetchData, groupFilter, groupOptions, cashFilter } = cashMovementsListQuery()
        const { formatCurrency } = currency()
        const { deletePopup, successToast, errorToast } = popups()
        const { exportData } = exportUtils()
        const cash = inject('cash')
        const startDateModal=ref(null)
        const endDateModal=ref(null)
        const fields = [
            { key: 'movement_type.name', label: 'Movimiento' },
            { key: 'amount', label: 'Cantidad'  },
            { key: 'student', label: 'Cliente'  },
            { key: 'observations', label: 'Observaciones' },
            { key: 'emit_date', label: 'Fecha de emisión' },
            { key: 'references', label: 'Referencia a' },
            { key: 'actions', label: 'Acciones' }
        ]
        const movementExportModal = ref('')
        const typeExportSelected=ref(null)
        const user = JSON.parse(localStorage.getItem('userData'))

        const CASH_MOVEMENTS_MODULE = 'movements'
        
        //& Métodos 

        /**
         * Exportar movimientos
         */
         const exportMovements = (id, fileType, datesSelected) => {
            if (datesSelected) {
                if (!startDateModal.value && !fileType=="employee") {
                    errorToast("Selecciona una fecha de comienzo.")
                    return
                }

                if (!endDateModal.value && !fileType=="employee") {
                    errorToast("Selecciona una fecha de fin")
                    return
                }

                let data = {
                    id: id, 
                    start_date: startDateModal.value,
                    end_date: endDateModal.value, 
                    type: fileType
                }

                let name
                if (!startDateModal.value || !endDateModal.value) {
                    name = "listado_movimientos"
                } else {
                    name = `listado_movimientos_${startDateModal.value}_${endDateModal.value}`
                }
                if(exportData('movements/export', data, name, fileType)) {
                    startDateModal.value = null
                    endDateModal.value = null
                    movementExportModal.value.hide()
                    successToast(`${fileType} descargado`)
                }else{
                    errorToast(`No ha sido posible descargar el ${fileType}`)
                }            
            }
        }

        const exportMovementsPDF = () => {
            startDateModal.value = null
            endDateModal.value = null
            movementExportModal.value.show()
            typeExportSelected.value = "PDF"
        }

        const exportMovementsPDFemployee = () => {
            startDateModal.value = null
            endDateModal.value = null
            typeExportSelected.value = "employee"
            exportMovements(cash.value.id, 'PDF', true )
        }

        const exportMovementsCSV = () => {
          startDateModal.value=null
          endDateModal.value=null
          movementExportModal.value.show()
          typeExportSelected.value="CSV"
        }

        const exportMovementsXLS = () => {
          startDateModal.value=null
          endDateModal.value=null
          movementExportModal.value.show()
          typeExportSelected.value="XLS"
        }

        if(!store.hasModule(CASH_MOVEMENTS_MODULE)){
            store.registerModule(CASH_MOVEMENTS_MODULE, cashMovementsModule)
        }

        onUnmounted(() => {
            if(store.hasModule(CASH_MOVEMENTS_MODULE)) {
                store.unregisterModule(CASH_MOVEMENTS_MODULE)
            }
        })

        return {
            currentPage,
            perPage,
            perPageOptions,
            fields,
            cash,
            ability,
            deletePopup,
            formatCurrency,
            format,
            fetchMovements,
            refetchData,
            totalCash,
            cashTable,
            exportMovements,
            exportMovementsPDF,
            exportMovementsCSV,
            exportMovementsXLS,
            exportMovementsPDFemployee,
            startDateModal,
            endDateModal,
            cash,
            movementExportModal,
            typeExportSelected,
            user
        };
    },
}
</script>
